import Vue from "vue"
import Vuex from "vuex"
import VuexORM from "@vuex-orm/core"
import * as mutations from "./mutations"
import * as actions from "./actions"
import modules from "./modules"

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const database = new VuexORM.Database()

const getVuexORMStore = () => {
    const state = () => ({})
    const getters = {}
    const mutations = {}
    const actions = {}
    return {
        namespaced: true,
        state: state(),
        getters,
        mutations,
        actions
    }
}

/**
 * Import VuexORM models
 */
let importModels = []

require.context('./models/', true, /\.js$/)
    .keys()
    .forEach((path, i) => {
        if(path !== './index.js') importModels.push(path)
    })

importModels.forEach((value) => {
    let path = value.substr(2, value.length)
    database.register(require(`./models/${path}`).default, getVuexORMStore())
})

/**
 * Initialize Vuex Store
 */
export default new Vuex.Store({
    plugins: [
        VuexORM.install(database),
        createPersistedState({
            paths: [
                'showChangelog',
                // "request-board",
                "auth.accessToken",
                "auth.refreshToken",
                "auth.zepplinMasterToken",
                "auth.isAuthenticated",
                "caller-id.disabled",
                "map.mapType",
                "tracker.sortBy",
                'tracker.showInfo'
            ]
        })
    ],
    state: {
        app: {
            title: "ERP",
            header: "request-board",
            version: null
        },
        system: {
            initialized: false
        },
        mainContentArea: {
            height: 0,
            width: 0
        },
        dimensions: {
            window: {
                width: 0,
                height: 0
            }
        },
        showChangelog: false
    },
    mutations,
    actions,
    modules,
    strict: true
});
